module.exports = __webpack_public_path__ + "static/media/04.07537780.jpg";